import React, { useContext } from 'react';
import { api } from '../../../api';
import { env } from '../../../env';
import { Upload, Button, Icon, Row, Col, Typography } from 'antd';
import {ModelContext} from "../../metadata/ModelSource";
import { ApplicationActionsContext } from '../../data/ApplicationDataSource';

const { Dragger } = Upload;
const { Text } = Typography;

export function VehicleImageUpload({ label, ...restProps }) {
  const appModel = useContext(ModelContext);
  const actions = useContext(ApplicationActionsContext);
  const apiCustomRequest = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append('image', file);
    const container = 'Application'
    const systemID = appModel.data.systemId;
    const attachTemplateURL = `/attachmentTemplates?container=${container}&containerRef=${systemID}`  ;
    const uploadResponseURL = env.fileUploadUrl;
    const templateResponse = await api.get(attachTemplateURL)
    let selectedItem = templateResponse.data.attachmentTemplateListItems[0];
    for (let index = 0; index < templateResponse.data.attachmentTemplateListItems.length; index++) {
      const tempItem = templateResponse.data.attachmentTemplateListItems[index];
      if (tempItem.id === 'ApplicationAttachment0036' || tempItem.id === 'QuoteAttachment0037') {
        selectedItem = tempItem;
        break;
      }
    }
    const secondFileData = {
      id: file.uid,
      "templateId": selectedItem.id,
      "description": "Photos - New Business & Endorsement",
      filename: file.name
    };
    try {
      const uploadResponse = await api.post(uploadResponseURL, formData);
      if (uploadResponse.status === 200) {
        onSuccess();
        appModel.notify({id: `uploadStatus-${file.name}`, message: `${file.name} file uploaded successfully`, type: 'success', overrideExisting: true})
        const bindResponse = await api.post(
          `/applications/${systemID}/documents`,
          secondFileData
        );
        if(bindResponse.status === 201 | 200) {
          actions.pullApplication();
        }
      } else if (uploadResponse.status === 'error') {
        throw new Error('Upload response returned error');
      }
    } catch (err) {
      appModel.notify({id: `uploadStatus-${file.name}`, message: `${file.name} file upload failed.`, type: 'error', overrideExisting: true})
      console.error('err', err);
      onError();
    }
  };

  const props = {
    name: 'image',
    //multiple is only supported on IE10+
    multiple: true,
    customRequest: (...args) => apiCustomRequest(...args),
    showUploadList: {
      showDownloadIcon: false
    }
  };

  return (
    <Row>
      <Col span={4}>
        <Text>{label}</Text>
      </Col>
      <Col span={12}>
        <Dragger {...props}>
          <Button>
            <Icon type='upload' /> Upload Files
          </Button>
        </Dragger>
      </Col>
    </Row>
  );
}